export default __webpack_public_path__ + "static/media/upload.476f15f7.svg";